// extracted by mini-css-extract-plugin
export default {"root":"styles_root__vjMSu","dark":"styles_dark__kOwTN","light":"styles_light__Brn2u"};